/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduledProposalDate model module.
 * @module model/ScheduledProposalDate
 * @version 1.0.0
 */
class ScheduledProposalDate {
    /**
     * Constructs a new <code>ScheduledProposalDate</code>.
     * @alias module:model/ScheduledProposalDate
     */
    constructor() { 
        
        ScheduledProposalDate.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduledProposalDate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledProposalDate} obj Optional instance to populate.
     * @return {module:model/ScheduledProposalDate} The populated <code>ScheduledProposalDate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledProposalDate();

            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'Date');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledProposalDate</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledProposalDate</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 予約日時（DB の値そのもの。丸めていないため一括取り消しへそのまま渡せる）
 * @member {Date} proposal_date
 */
ScheduledProposalDate.prototype['proposal_date'] = undefined;

/**
 * その日時に予約されている件数
 * @member {Number} count
 */
ScheduledProposalDate.prototype['count'] = undefined;






export default ScheduledProposalDate;

